import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { homeAccessRoles } from './access';

export const homeRoutes: RouteObject[] = [
  {
    path: 'home',
    async lazy() {
      const { HomePage } = await import('./pages/HomePage');
      return { Component: HomePage };
    },
    handle: defineHandle({
      roles: [...homeAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.home',
    }),
  },
];
